import useTranslation from '../useTranslation';

import useSelectField from 'hooks/useSelectField';

import type { FieldValues, Props } from './types';

const useData = <T extends FieldValues>({
    control,
    isOpen,
    isRequired = false,
    name,
    onPanelClose,
    onPanelOpen,
    ref
}: Props<T>) => {
    const { CHEMICAL_MIX_IS_REQUIRED } = useTranslation();

    return useSelectField<T>({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref,
        requiredMessage: isRequired ? CHEMICAL_MIX_IS_REQUIRED : false
    });
};

export default useData;
